import React from 'react';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import './LiveVotingTopBar.scss';
import Icon from '../../../elements/icons/Icon';

export default class LiveVotingTopBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isConnected: true, hideConnectionIcon: false, mounted: false};
        this.handleConnectionStateChange = this.handleConnectionStateChange.bind(this);
    }
    componentDidMount() {
        // global app object may not exist (on dashboard)
        try {
            app.api?.voting.socket.on('connect', this.handleConnectionStateChange);
            app.api?.voting.socket.on('disconnect', this.handleConnectionStateChange);
            this.handleConnectionStateChange();
        } catch (e) {
            console.warn("Don't worry about this one if you are not running the app: ", e);
            this.setState({hideConnectionIcon: true});
        }
    }
    componentWillUnmount() {
        // global app object may not exist (on dashboard)
        try {
            app.api?.voting.socket.off('connect', this.handleConnectionStateChange);
            app.api?.voting.socket.off('disconnect', this.handleConnectionStateChange);
        } catch (e) {
            console.warn("Don't worry about this one if you are not running the app: ", e);
        }
    }
    render() {
        // console.log('Has socket connection: ', this.state.isConnected);
        let statusIcon;
        if (this.state.isConnected) {
            statusIcon = <Icon className="full-center" src="img/livevoting-connected.png" color="#060" />;
        } else {
            statusIcon = (
                <Icon
                    className="full-center"
                    src="img/livevoting-disconnected.png"
                    color="#f00"
                    size={24}
                    style={{
                        backgroundSize: 'contain',
                        marginTop: 2,
                    }}
                />
            );
        }

        let headerStyle =
            this.props.settings && this.props.settings.header
                ? {
                      backgroundColor: this.props.settings.header,
                      color: this.props.settings.headerText,
                  }
                : undefined;

        return (
            <TopBarEvent
                {...this.props}
                returnURL="../.."
                style={headerStyle}
                icons={[
                    this.state.hideConnectionIcon ? null : (
                        <div className="LiveVoting-connection-status" key="connectionStatus">
                            {statusIcon}
                        </div>
                    ),
                ]}
            />
        );
    }
    handleConnectionStateChange() {
        let isConnected = app.api?.voting.socket.isConnected();
        this.setState({
            isConnected,
        });
    }
}
